const GROUPVIEW = {
  listGroups: "Lista de grupos",
  newGroup: "Nuevo Grupo",

  name: "Nombre",
  description: "Descripción",
  company: "Compañía",
  state: "Estado",
  actions: "Acciones",

  emptyGroups: "No hay grupos registrados.",
  groups: "Grupos",

  acept: "Aceptar",
  cancel: "Cancelar",

  DIALOGS: {
    titleDelete: `Eliminar Grupo: {description}`,
    textDelete: `Ésta opción no se puede deshacer, está seguro?`
  },

  NOTIFY: {
    titleDeleteGorup: `Eliminar grupos`,
    NotAutorization: `No posee permisos para realizar esta acción.`,
    error: `Ocurrio un error, al eliminar el grupo`,
    goups: "Grupos",
    ActionUnavaliable: "Acción no disponible en este momento."
  },

  remember: "Recuerda no usar <strong>carácteres especiales</strong>.",
  name: "Nombre",
  save: "Guardar",
  clean: "Limpiar"
};

export default { GROUPVIEW };
